/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { styled } from 'fierry/react';

import BoardUser from 'solis/claude/logic/board/user';
import GalaxyUser from 'solis/claude/logic/galaxy/user';


const getUser = ({ board, galaxy, user }) =>
{
  return board ? new BoardUser(board, user) : new GalaxyUser(galaxy, user);
};


const getColor = (props) =>
{
  return getUser(props).getColor();
};


const getBackground = (props) =>
{
  return props.user == null || props.hollow ? 'transparent' : `var(--${getColor(props)}-11)`;
};


const getBorder = (props) =>
{
  return props.user == null || !props.hollow ? 'none' : `1.5px solid var(--${getColor(props)}-11)`;
};


export default styled.span`
  flex-shrink: 0;

  width: 8px;
  height: 8px;
  border-radius: 50%;
  box-sizing: border-box;

  border: ${props => getBorder(props)};
  background-color: ${props => getBackground(props)};
`;
